import React, { Component } from 'react'
import Loading from '../tags/Loading'
import { connect } from 'react-redux'
import AddToHomeScreen from '../tags/AddToHomeScreen'
import AutoNotifications from '../tags/AutoNotifications'
import HomeContent from '../tags/HomeContent'
import { Link } from 'react-router-dom'
import { getProperty } from '../../helpers/properties'
import { getConfiguration } from '../../helpers/configuration'
import { Notifications } from '@mui/icons-material'

const mapStateToProps = (
  { courses: { selectedCourseCode, data }, course: { selectedCourse }, sliders, enrolledTeachingPeriods, maintenancePeriods : { data: { maintenancePeriod }} }
) => {
  return {
    hasSliders: sliders[selectedCourseCode].data.length > 0,
    courseId: selectedCourseCode,
    isLoadingSlider: (!sliders[selectedCourseCode].isFetchingDefaultSliderError && sliders[selectedCourseCode].receivedAt === null) || sliders[selectedCourseCode].isFetchingDefaultSlider,
    isLoadingSliderError: sliders[selectedCourseCode].isFetchingDefaultSliderError,
    hasTeachingPeriods: enrolledTeachingPeriods[selectedCourseCode].teachingPeriods.length > 0,
    admissionCategory: selectedCourse.admissionCategory,
    isOffshoreFlag: selectedCourse.isOffshoreFlag,
    maintenancePeriod: maintenancePeriod
  }
}
class Home extends Component {
  constructor(props) {
    super(props)
    this.state = {
      vuCalendar_url: getProperty('vuCalendarSiteUrl'),
      vuCollaborate_url: getProperty('vuCollaborateUrl'),
      allocateplus_url: getProperty('allocatePlusSiteUrl'),
      studentemail_link: getProperty('studentEmailLinkUrl'),
      isActiveOutageAlert: false
    }
  }

  componentDidMount(){
    let startTime =  this.props.maintenancePeriod.dateRange.value;
    let currentTime = Math.floor(new Date().getTime()/1000);

    this.setState({
      isActiveOutageAlert: currentTime >= startTime-43200 && currentTime < startTime
    })
  }
  render() {
    return (
      <div className="page page__home">
        <AddToHomeScreen />

        <div className="row">
          <div className="col-xs-12">
            <AutoNotifications />

            { this.state.isActiveOutageAlert ? 
              (
                <div className="tile-notification">
                  <div className="tile-content">
                      <h2><Notifications className="btn-point-events"/> {this.props.maintenancePeriod.outageAlertTitle}</h2>
                    <p>{this.props.maintenancePeriod.outageAlertMessage}</p>
                  </div>
                </div>
              ): null
            }
          </div>
        </div>

        {this.props.isLoadingSlider ? (
          <div className="row">
            <div className="col-xs-12">
              <Loading />
            </div>
          </div>
        ) : this.props.isLoadingSliderError ? (
          <div className="row">
            <div className="col-xs-12">
              <div className="empty-state-container empty-state-container--default">
                <h2>Error loading content</h2>
                <p>We seem to be having technical difficulties loading your content, please refresh your browser, and try again.</p>
              </div>
            </div>
          </div>
        ) : this.props.hasSliders ? (
          <HomeContent />
        ) : this.props.hasTeachingPeriods ? (
          <div className="row">
            <div className="col-xs-12">
              <div className="empty-state-container empty-state-container--default">
                <h2>No content found</h2>
                <p>
                  Content will display when unit/s commence.
                  <br />
                  You can still access <a href={this.state.vuCollaborate_url}>VU Collaborate</a>,{' '}
                  {!this.props.isOffshoreFlag ? <a href={this.state.vuCalendar_url}>VU Calendar</a> : ''}{' '}
                  {this.props.isOffshoreFlag ? <a href={this.state.allocateplus_url}>MyTimetable</a> : ''} and your <a href={this.state.studentemail_link}>Student Email</a>.
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div className="row">
            <div className="col-xs-12">
              <div className="empty-state-container empty-state-container--default">
                <h2>No content found</h2>
                <p>
                  You have not enrolled into any units during this teaching period. <br />
                  Click to <Link to={getConfiguration('baseUrl') + '/enrolments'}>review your enrolment</Link>.
                  <br />
                  You can still access <a href={this.state.vuCollaborate_url}>VU Collaborate</a>,{' '}
                  {!this.props.isOffshoreFlag ? <a href={this.state.vuCalendar_url}>VU Calendar</a> : ''}{' '}
                  {this.props.isOffshoreFlag ? <a href={this.state.allocateplus_url}>MyTimetable</a> : ''} and your <a href={this.state.studentemail_link}>Student Email</a>.
              </p>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default connect(mapStateToProps)(Home)
